import { render, staticRenderFns } from "./modal_saida.vue?vue&type=template&id=988c7e7e&scoped=true"
import script from "./modal_saida.vue?vue&type=script&lang=js"
export * from "./modal_saida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c7e7e",
  null
  
)

export default component.exports